<template>
  <md-dialog
    :md-active.sync="show"
    :md-close-on-esc="false"
    class="warning-dialog"
    @md-clicked-outside="closeDialog"
    @keyup.esc="closeDialog"
  >
    <md-dialog-title>
      {{ title || "Are You Sure?" }}
    </md-dialog-title>
    <div class="md-dialog-content md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
      <div class="md-subheading warning-text">
        {{ message }}
      </div>
      <div dir="rtl">
        <md-button class="md-primary" @click="approveDialog">{{ approveButton || "Approve" }}</md-button>
        <md-button @click="closeDialog">{{ closeButton || "Cancel" }}</md-button>
      </div>
    </div>
  </md-dialog>
</template>

<script>
export default {
  name: "AreYouSure",
  props: ["show", "title", "message", "approveButton", "closeButton"],
  setup(props, { emit }) {
    const closeDialog = () => {
      emit("close");
    };
    const approveDialog = () => {
      emit("approve");
    };

    return {
      closeDialog,
      approveDialog,
    };
  },
};
</script>
